import { useState, useCallback } from 'react';
import { QUICK_STEPS } from '../../components/estimation/quick/config/QuickSteps';

const initialFormData = {
  propertyType: null,
  buildingDetails: {
    units: 1,
    commonAreas: false
  },
  area: 0,
  location: {
    postcode: '',
    city: '',
    address: ''
  },
  renovationLevel: null,
  keyElements: {
    windows: false,
    kitchen: false,
    bathroom: false
  },
  networks: {
    electricity: 'unknown',
    plumbing: 'unknown',
    heating: 'unknown'
  },
  finishingLevel: null,
  accessibility: {
    floor: 0,
    elevator: false,
    narrowStreet: false
  },
  constraints: {
    urgent: false,
    historicArea: false,
    desiredDelay: 6
  }
};

export const useQuickEstimate = () => {
  const [currentStep, setCurrentStep] = useState(QUICK_STEPS[0].id);
  const [formData, setFormData] = useState(initialFormData);
  const [error, setError] = useState<string | null>(null);

  const handleStepDataChange = useCallback((field: string, value: any) => {
    setFormData(prev => {
      const newData = { ...prev };
      
      // Gestion spéciale pour le type de bien
      if (field === 'propertyType') {
        newData.propertyType = value;
        // Réinitialiser buildingDetails si ce n'est pas un immeuble
        if (value !== 'building') {
          newData.buildingDetails = { units: 1, commonAreas: false };
        }
      } else {
        newData[field] = value;
      }
      
      return newData;
    });
    setError(null);
  }, []);

  const handleNext = useCallback(() => {
    const currentIndex = QUICK_STEPS.findIndex(step => step.id === currentStep);
    if (currentIndex < QUICK_STEPS.length - 1) {
      // Trouver la prochaine étape valide
      for (let i = currentIndex + 1; i < QUICK_STEPS.length; i++) {
        const nextStep = QUICK_STEPS[i];
        if (!nextStep.condition || nextStep.condition(formData)) {
          setCurrentStep(nextStep.id);
          return true;
        }
      }
    }
    return false;
  }, [currentStep, formData]);

  const handleBack = useCallback(() => {
    const currentIndex = QUICK_STEPS.findIndex(step => step.id === currentStep);
    if (currentIndex > 0) {
      // Trouver l'étape précédente valide
      for (let i = currentIndex - 1; i >= 0; i--) {
        const prevStep = QUICK_STEPS[i];
        if (!prevStep.condition || prevStep.condition(formData)) {
          setCurrentStep(prevStep.id);
          return true;
        }
      }
    }
    return false;
  }, [currentStep, formData]);

  const handleReset = useCallback(() => {
    setFormData(initialFormData);
    setCurrentStep(QUICK_STEPS[0].id);
    setError(null);
  }, []);

  return {
    currentStep,
    formData,
    error,
    handleNext,
    handleBack,
    handleStepDataChange,
    handleReset
  };
};

